module.exports = __webpack_public_path__ + "static/media/jack_summit_intro_small_13.78ca4efe.jpg";